import PropTypes from "prop-types";
import { cn } from "@/lib/utils";

/**
 * Says whether the board is live (projects/task-live-refresh, D7): the
 * user should know other people's changes arrive on their own, and know
 * when they've stopped arriving.
 */
export default function LiveStatus({ status }) {
  if (status === "off") return null;
  const live = status === "live";
  return (
    <span
      className="inline-flex items-center gap-1.5 text-xs text-muted-foreground"
      role="status"
      title={
        live
          ? "Changes from anyone on this board show up here within a few seconds."
          : "Couldn't check for changes — retrying. What you see may be out of date."
      }
    >
      <span
        aria-hidden="true"
        className={cn(
          "inline-block size-2 rounded-full",
          live ? "bg-success" : "bg-warning",
        )}
      />
      {live ? "Live" : "Reconnecting…"}
    </span>
  );
}

LiveStatus.propTypes = {
  status: PropTypes.oneOf(["live", "reconnecting", "off"]).isRequired,
};
